module.exports = __webpack_public_path__ + "images/emoji/egg.8593000a2153231e216d.png";